import Block from '../../common.blocks/block'
import $ from 'jquery'

export default class Withdrawal extends Block {
	static title = 'withdrawal'

	constructor($el) {
		super($el)

		this.button = this.$el.findElement('button')
		this.loader = this.$el.findElement('loader')

		this.$el.on('submit', (e) => {
			e.preventDefault()
			this.setLoading(true)

			this.data = new FormData(this.$el.get(0))
			this.data.append('ajax', true)
			this.data.append('withdrawal', true)

			$.ajax({
				method: 'POST',
				processData: false,
				contentType: false,
				cache: false,
				url: '/account',
				data: this.data,
			})
				.done((json) => {
					// check for errors
					if ((!json.error && !json.error_message) || json.success) {
						this.submitForm()
					} else if (json.error_message) {
						this.setLoading(false)
						$(document).trigger(
							'message:error',
							this.$el.data(json.error_message),
						)
					} else {
						this.setLoading(false)
						$(document).trigger('message:error', json.error)
					}
				})
				.fail((error) => {
					this.setLoading(false)
					$(document).trigger('message:error', error.message)
				})
		})
	}

	setLoading(bool) {
		if (bool) {
			this.loader.addModifier('active')
			this.button.prop('disabled', true)
		} else {
			this.loader.removeModifier('active')
			this.button.prop('disabled', false)
		}
	}

	submitForm() {
		this.formData = new FormData(this.$el.get(0))
		this.formData.append('ajax', true)
		this.formData.append('submit', true)

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: window.location.href,
			data: this.formData,
		})
			.done((json) => {
				// check for errors
				if (!json.error) {
					window.location.href = json.success
				} else {
					$(document).trigger('message:error', json.error)
				}
			})
			.fail((error) => {
				$(document).trigger('message:error', error.message)
			})
			.always(() => this.setLoading(false))
	}
}
